'use strict';
import PropTypes from 'prop-types';

import "./Content.css";

const Content = (props) => {
  const {
    value = '',
  } = props;
  let className = props.className ? props.className : 'content';
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );
};


Content.propTypes = {
  value: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default Content;
